import { v4 as uuidv4 } from 'uuid';
import Storage from './Storage';

const SSO_DEVICE_ID_KEY = 'grupoimpar:sso:deviceId';
const SSO_REFRESH_TOKEN_KEY = 'grupoimpar:refreshToken';

export const getOrCreateSsoDeviceId = () => {
  const existing = Storage.get( SSO_DEVICE_ID_KEY );
  if ( existing ) return existing;
  const created = uuidv4();
  Storage.set( SSO_DEVICE_ID_KEY, created );
  return created;
};

export const setRefreshToken = ( refreshToken?: string ) => {
  if ( refreshToken ) Storage.set( SSO_REFRESH_TOKEN_KEY, refreshToken );
};

export const clearSsoSessionKeys = () => {
  Storage.clear( SSO_REFRESH_TOKEN_KEY );
};

export default {
  getOrCreateSsoDeviceId,
  setRefreshToken,
  clearSsoSessionKeys,
};
